<template>
    <div>
<div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
<div id="experiencefragment-8535a5402f" class="cmp-experiencefragment cmp-experiencefragment--footer">
<div class="xf-content-height">
    


<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
    
    <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">


<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
    
    <div class="footer aem-GridColumn aem-GridColumn--default--12"><footer>
    <div class="support">
        <div class="max">
            <div>
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/support-graphic.coreimg.100{.width}.png/1679552727554/chat-icon-for-footer.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/Chat Icon for Footer.png" data-title="Chat Icon Footer" id="image-f35c0a4205" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="Chat Icon Footer" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/support-graphic.coreimg.100.300.png/1679552727554/chat-icon-for-footer.png">
    
    
    
</div>

    

</div>
            <div>
<div id="text-6be5fc3f7a" class="cmp-text">
    <p><b>Support at every Step</b></p>
<p>We’re committed to partner with you to make sure you have what you need to succeed.&nbsp;</p>

</div>

    

</div>
            <div><div class="mchp-button-wrapper" isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manual,url:,[]">
	
		<a cw-component-level="no" aria-label="Learn About Support" role="button" href="https://microchip-stage65e.adobecqms.net/en-us/support" class="mchp-button mchp-button-regular red-outline" data-name="Learn about Support">
			<span class="mchp-button__span">Learn about Support</span>
		</a>
		
	
		
	

</div>


    

</div>
        </div>
    </div>
    <div class="main">
        <div class="max">
            <div>
                <div class="accordion-list"><input type="checkbox" class="accordion-input" id="section-1">
<label for="section-1" class="accordion-label">
<div id="text-5521a8ec2b" class="cmp-text">
    <p>About</p>

</div>

    

</label>
<div class="mchp-component-list" style="display: block; max-height: none;">
    
    
    <div class="mchp-component-items">
        <div class="mchp-component-item mchp-component-item--first "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/corporate-overview" class="mchp-link__link" aria-label="Company">Company</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/careers" class="mchp-link__link" aria-label="Careers">Careers</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/contact-us" class="mchp-link__link" aria-label="Contact Us">Contact Us</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/media-center" class="mchp-link__link" aria-label="Media Center">Media Center</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/investors" class="mchp-link__link" aria-label="Investor Relations">Investor Relations</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item  mchp-component-item--last"><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/corporate-responsibility" class="mchp-link__link" aria-label="Corporate Responsibility">Corporate Responsibility</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>

    </div>
</div>
</div>
            </div>
            <div>
                <div class="accordion-list"><input type="checkbox" class="accordion-input" id="section-2">
<label for="section-2" class="accordion-label">
<div id="text-ea8a67216c" class="cmp-text">
    <p>Support</p>

</div>

    

</label>
<div class="mchp-component-list" style="display: block; max-height: none;">
    
    
    <div class="mchp-component-items">
        <div class="mchp-component-item mchp-component-item--first "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/support/forums" class="mchp-link__link" aria-label="Microchip Forums">Microchip Forums</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/support/forums" class="mchp-link__link" aria-label="AVR Freaks">AVR Freaks</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/support/design-help" class="mchp-link__link" aria-label="Design Help">Design Help</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/support/technical-support" class="mchp-link__link" aria-label="Technical Support">Technical Support</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manual,url:,[]">
    
    
        <a cw-component-level="no" href="https://www.microchip.com" class="mchp-link__link" aria-label="Export Control Data">Export Control Data</a>
        <span class="mchp-link__separator"></span>
    
</div>

    

</div>
</div>
<div class="mchp-component-item  mchp-component-item--last"><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manual,url:,[]">
    
    
        <a cw-component-level="no" href="https://www.microchip.com" class="mchp-link__link" aria-label="PCNs">PCNs</a>
        <span class="mchp-link__separator"></span>
    
</div>

    

</div>
</div>

    </div>
</div>
</div>
            </div>
            <div>
                <div class="accordion-list"><input type="checkbox" class="accordion-input" id="section-3">
<label for="section-3" class="accordion-label">
<div id="text-229415b3f9" class="cmp-text">
    <p>Quick Links</p>

</div>

    

</label>
<div class="mchp-component-list" style="display: block; max-height: none;">
    
    
    <div class="mchp-component-items">
        <div class="mchp-component-item mchp-component-item--first "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
    
        <a cw-component-level="no" target="_blank" href="https://www.microchipdirect.com/%20" class="mchp-link__link" aria-label="Microchip Direct">Microchip Direct</a>
        <span class="mchp-link__separator"></span>
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
    
        <a cw-component-level="no" target="_blank" href="https://secure.microchip.com/mu" class="mchp-link__link" aria-label="Microchip University">Microchip University</a>
        <span class="mchp-link__separator"></span>
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
    
        <a cw-component-level="no" href="https://www.microchip.com/mymicrochip/%20" class="mchp-link__link" aria-label="myMicrochip">myMicrochip</a>
        <span class="mchp-link__separator"></span>
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/media-center/blog" class="mchp-link__link" aria-label="Blogs">Blogs</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/tools-resources/reference-designs" class="mchp-link__link" aria-label="Reference Designs">Reference Designs</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item  mchp-component-item--last"><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/products/selection-tools/parametric-search-tool" class="mchp-link__link" aria-label="Parametric Search">Parametric Search</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>

    </div>
</div>
</div>
            </div>
            <div>
                <div><div>
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/microchip-logo.coreimg.100{.width}.png/1679552752743/microchip-logo.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/Microchip Logo.png" data-title="Microchip Logo" id="image-f88d5c1d9a" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="Microchip Logo" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/microchip-logo.coreimg.100.400.png/1679552752743/microchip-logo.png">
    
    
    
</div>

    

</div>
<div>
<div id="text-cf91d72ddd" class="cmp-text">
    <p>Microchip Technology Inc.</p>
<p>2355 West Chandler Blvd.</p>
<p>Chandler, Arizona, USA 85224-6199</p>
<p>(480) 792-7200</p>

</div>

    

</div>
<div><div class="mchp-component-list">
    
    
    <div class="mchp-component-items">
        <div class="mchp-component-item mchp-component-item--first "><div class="image">
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image.coreimg.100{.width}.png/1679552773318/facebook-icon.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/FaceBook Icon.png" data-title="Microchip Facebook" id="image-6afb710061" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    <a class="cmp-image__link" href="https://www.facebook.com/pages/Microchip-Technology-Inc/20320981741" aria-label="Microchip Facebook" data-cmp-hook-image="link" target="_blank">
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="Microchip Facebook" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image.coreimg.100.300.png/1679552773318/facebook-icon.png">
    </a>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="image">
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_1070448314.coreimg.100{.width}.png/1679552782649/linkedin-icon.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/LinkedIn Icon.png" data-title="Microchip LinkedIn" id="image-971ca505f4" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    <a class="cmp-image__link" href="https://www.linkedin.com/company/microchip-technology" aria-label="Microchip LinkedIn" data-cmp-hook-image="link" target="_blank">
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="Microchip LinkedIn" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_1070448314.coreimg.100.300.png/1679552782649/linkedin-icon.png">
    </a>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="image">
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_431663958.coreimg.100{.width}.png/1679552794174/twitter-logo.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/Twitter Logo.png" data-title="Microchip Twitter" id="image-027750dd88" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    <a class="cmp-image__link" href="https://twitter.com/MicrochipTech" aria-label="Microchip Twitter" data-cmp-hook-image="link" target="_blank">
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="Microchip Twitter" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_431663958.coreimg.100.300.png/1679552794174/twitter-logo.png"  style="width:0px;padding-bottom:0px">
    </a>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="image">
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_302000198.coreimg.100{.width}.png/1679552809312/youtube-icon.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/Youtube Icon.png" id="image-eb3e4ec2fc" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    <a class="cmp-image__link" href="https://www.youtube.com/user/MicrochipTechnology" data-cmp-hook-image="link" target="_blank">
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_302000198.coreimg.100.300.png/1679552809312/youtube-icon.png">
    </a>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="image">
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_1599962820.coreimg.100{.width}.png/1679552817535/instagram-icon.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/Instagram Icon.png" data-title="Microchip Instagram" id="image-0cd01380e3" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    <a class="cmp-image__link" href="https://www.instagram.com/microchiptechnologyinc/" aria-label="Microchip Instagram" data-cmp-hook-image="link" target="_blank">
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="Microchip Instagram" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_1599962820.coreimg.100.300.png/1679552817535/instagram-icon.png">
    </a>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item  mchp-component-item--last"><div class="image">
<div data-cmp-lazy="" data-cmp-lazythreshold="0" data-cmp-src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_181251106.coreimg.100{.width}.png/1679552828563/snap.png" data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200" data-asset="https://microchip-stage65e.adobecqms.net/content/dam/mchp/images/footer/Snap.png" data-title="Microchip Weibo" id="image-67789d044d" class="cmp-image" itemscope="" itemtype="http://schema.org/ImageObject">
    <a class="cmp-image__link" href="https://www.weibo.com/microchiptech" aria-label="Microchip Weibo" data-cmp-hook-image="link" target="_blank">
        <img class="cmp-image__image" itemprop="contentUrl" data-cmp-hook-image="image" alt="Microchip Weibo" src="https://microchip-stage65e.adobecqms.net/content/experience-fragments/mchp/en_us/site/footer/master/_jcr_content/root/responsivegrid/footer/socialmedialinks/image_181251106.coreimg.100.300.png/1679552828563/snap.png">
    </a>
    
    
</div>

    

</div>
</div>

    </div>
</div>
</div></div>
            </div>
            <div>
                <p>© Copyright 1998-2023 Microchip Technology Inc. All rights reserved. Shanghai ICP Recordal No.09049794
                </p><p>
            </p></div>
            <div>
                <div><div class="mchp-component-list">
    
    
    <div class="mchp-component-items">
        <div class="mchp-component-item mchp-component-item--first "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/legal-information" class="mchp-link__link" aria-label="Legal">Legal</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item "><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/legal-information/privacy-policy" class="mchp-link__link" aria-label="Privacy Policy">Privacy Policy</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>
<div class="mchp-component-item  mchp-component-item--last"><div class="link"><div isclickwrapped="no" clickwrapconfig=",,,saleforceformtitle:default,saleforceformpath:,,manualapproval,url:,[]">
    
        <a cw-component-level="no" href="https://microchip-stage65e.adobecqms.net/en-us/about/legal-information/microchip-cookie-statement" class="mchp-link__link" aria-label="Cookies">Cookies</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
</div>

    </div>
</div>
</div>
            </div>
        </div>
    </div>
    
    
        <div>
            <div class="mchp-cookie">
    <!-- MODAL HIDDEN UNTIL CLIENT DECIDES
    <div class="mchp-cookie-modal">
        <div class="mchp-cookie-settings">
            <div class="mchp-cookie-content">
                <div class="mchp-cookie-heading">
                    <div class="heading-menu-and-logo">
                        <div class="mchp-cookie-mobile-menu">
                            <div class="mchp-cookie-hamburger-holder is-active">
                                <i class="fas fa-bars"></i>
                            </div>
                            <div class="mchp-cookie-mobile-close is-hidden">
                                <i class="fas fa-times"></i>
                            </div>
                            <div class="cookie-mobile-wrap is-hidden">
                                <ul>
                                    <a href="#yourPrivacy">
                                        <li class="cookie-tab-active">Your Policy</li>
                                    </a>
                                    <a href="#essential">
                                        <li>Essential</li>
                                    </a>
                                    <a href="#performance">
                                        <li>Performance and functional</li>
                                    </a>
                                    <a href="#analytics">
                                        <li>Analytics</li>
                                    </a>
                                    <a href="#social">
                                        <li>Social Networking</li>
                                    </a>
                                    <a href="#cookie">
                                        <li>Cookie Policy</li>
                                    </a>
                                    <a href="#privacyPolicy">
                                        <li>Privacy Policy</li>
                                    </a>
                                </ul>
                            </div>
                        </div>
                        <div class="mchp-cookie-logo">
                            <img src="https://microchip-stage65e.adobecqms.net/content/dam/mchp/microchip.png" width="150px" alt="">
                        </div>
                    </div>
                    <div class="mchp-cookie-title">
                        <h3>Privacy Preference Centre</h3>
                    </div>
                </div>
                <div class="mchp-cookie-body" id="tabs">
                    <div class="mchp-vertical-tabs">
                        <ul>
                            <a href="#yourPrivacy">
                                <li class="cookie-tab-active">Your Policy</li>
                            </a>
                            <a href="#essential">
                                <li>Essential</li>
                            </a>
                            <a href="#performance">
                                <li>Performance and functional</li>
                            </a>
                            <a href="#analytics">
                                <li>Analytics</li>
                            </a>
                            <a href="#social">
                                <li>Social Networking</li>
                            </a>
                            <a href="#cookie">
                                <li>Cookie Policy</li>
                            </a>
                            <a href="#privacyPolicy">
                                <li>Privacy Policy</li>
                            </a>
                        </ul>
                    </div>
                    <div class="mchp-tab-content visible" id="yourPrivacy">
                        <div class="tab-wrap">
                            <h4 class="mchp-tab-content-title">Your Privacy</h4>
                            <p>
                                Our cookies are free. In order to provide with the best
                                experience possible, we might sometimes track
                                information about you on our web site; we don’t sell
                                your information, but we use it to personalize your
                                web experience, track analytics and for target
                                advertising (which is really just telling you about our
                                latest products that meet your preferences).
                            </p>
                            <p>
                                Just like picking your favorite cookie flavor, there are
                                some cookies you can choose not to allow. Click on
                                the different categories to find out more. Please note
                                that blocking some types of cookies may impact your
                                experience of the site and services we are able to offer.
                                Just like taking the chocolate chips out of your cookie.
                                It just doesn’t taste as good.
                            </p>
                        </div>
                    </div>

                    <div class="mchp-tab-content" id="essential">
                        <div class="tab-wrap">
                            <h4 class="mchp-tab-content-title">Essential</h4>
                            <p>
                                Like the dough of a cookie, the essential web site
                                cookies hold the site together and are strictly
                                necessary for functioning through our web sites and to
                                use some of the features such as access to our secure
                                areas. You can block them or delete them by changing
                                your browser settings, check out our cookie policy
                                page to find out how, however who wants a web site
                                that doesn’t function….or a cookie that doesn’t taste
                                like a cookie?
                            </p>
                        </div>
                    </div>

                    <div class="mchp-tab-content" id="performance">
                        <div class="tab-wrap">
                            <h4 class="mchp-tab-content-title">Performance and functional</h4>
                            <p>
                                These cookies are used to make our site more
                                interesting, like nuts and fruit and chocolate chips!
                                They enhance the performance and functionality of
                                our websites but are non-essential to their use.
                                However, without these cookies certain functionality
                                like videos.
                            </p>
                            <p>
                                To refuse these cookies, please follow the
                                instructions on our cookie policy page under the
                                heading "How can I control cookies?“
                            </p>
                            <p>
                                Alternatively, please click on the relevant opt-out
                                link or toggle button below:
                            </p>
                            <p>
                                <span>Hotjar</span>
                                Ltd.: <a href="https://www.hotjar.com/privacy/do-not-track/" target="_blank">https://www.hotjar.com/privacy/do-not-track/</a>
                            </p>
                            <p>
                                <span>Google</span>
                                LCC: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">https://tools.google.com/dlpage/gaoptout</a>
                            </p>
                            <p>
                                <span>Turn off hotjar cookies?</span>
                                <label class="switch">
                                    <input type="checkbox" class="performance-hotjar" name="hotjar" value="checked">
                                    <span class="slider round"></span>
                                </label>
                            </p>
                            <p>
                                <span>Turn off Google cookies?</span>
                                <label class="switch">
                                    <input type="checkbox" class="performance-google" name="google" value="checked">
                                    <span class="slider round"></span>
                                </label>
                            </p>
                        </div>
                    </div>

                    <div class="mchp-tab-content" id="analytics">
                        <div class="tab-wrap">
                            <h4 class="mchp-tab-content-title">Analytics</h4>
                            <p>
                                These cookies collect information that is used
                                either in aggregate form to help us understand
                                how our Websites are being used or how effective
                                our marketing campaigns are, or to help us
                                customize our Websites for you.
                            </p>
                            <p>
                                To refuse these cookies please click on the
                                relevant opt-out link below:
                            </p>
                            <p>
                                <span>Hotjar</span>
                                Ltd.: <a href="https://www.hotjar.com/privacy/do-not-track/" target="_blank">https://www.hotjar.com/privacy/do-not-track/</a>
                            </p>
                            <p>
                                <span>Google</span>
                                LCC: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">https://tools.google.com/dlpage/gaoptout</a>
                            </p>
                            <p>
                                <span>Turn off hotjar cookies?</span>
                                <label class="switch">
                                    <input type="checkbox" class="analytics-hotjar" name="hotjar" value="checked">
                                    <span class="slider round"></span>
                                </label>
                            </p>
                            <p>
                                <span>Turn off Google cookies?</span>
                                <label class="switch">
                                    <input type="checkbox" class="analytics-google" name="google" value="checked">
                                    <span class="slider round"></span>
                                </label>
                            </p>
                        </div>
                    </div>

                    <div class="mchp-tab-content" id="social">
                        <div class="tab-wrap">
                            <h4 class="mchp-tab-content-title">Social Networking</h4>
                            <p>
                                These cookies are used to enable you to share pages
                                and content that you find interesting on our Websites
                                through third party social networking and other
                                websites. These cookies may also be used for
                                advertising purposes too
                            </p>
                            <p>
                                To refuse these cookies please click on the
                                relevant opt-out link below:
                            </p>
                            <p>
                                <span>Facebook, Inc.:</span>
                                <a href="https://www.facebook.com/policies/cookies/">https://www.facebook.com/policies/cookies/</a>
                            </p>
                        </div>
                    </div>

                    <div class="mchp-tab-content" id="cookie">
                        <div class="tab-wrap">
                            <h4 class="mchp-tab-content-title">Cookie Policy</h4>
                            <a href="https://www.microchip.com/about-us/legal-information/cookies" target="_blank">https://www.microchip.com/about-us/legal-information/cookies</a>
                        </div>
                    </div>

                    <div class="mchp-tab-content" id="privacyPolicy">
                        <div class="tab-wrap">
                            <h4 class="mchp-tab-content-title">Privacy Policy</h4>
                            <a href="https://www.microchip.com/about-us/legal-information/privacy-policy" target="_blank">https://www.microchip.com/about-us/legal-information/privacy-policy</a>
                        </div>
                    </div>

                </div>
                <div class="mchp-cookie-footer">
                    <button class="mchp-cookie-save">
                        Save Settings
                    </button>
                </div>
            </div>
        </div>
    </div>
    -->

    <div class="mchp-cookie-banner mchp-section-container">
        <div class="mchp-cookie-banner__content mchp-section-container-max-width">
            <div class="mchp-cookie-banner__message">
                This website uses cookies for analytics, personalization, and other purposes.
                Click to learn more. By continuing to browse, you agree to our use of cookies
                as described in our Cookies Statement.
            </div>
            <div class="mchp-cookie-banner__actions">
                <div><div clickwrapconfig=",,saleforceformtitle:,saleforceformpath:,,,url:,[]">
    
        <a href="https://microchip-stage65e.adobecqms.net/en-us/about/legal-information/privacy-policy" class="mchp-link__link" aria-label="Privacy Policy">Privacy Policy</a>
        <span class="mchp-link__separator"></span>
    
    
</div>

    

</div>
                <div class="mchp-button-wrapper">
                    <a role="button" href="#" class="mchp-button solid" onclick="setCookieAgree();" aria-label="Accept Cookies" data-name="Accept Cookies">
                        <span>Accept Cookies</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
        </div>
    
</footer></div>

    
</div>
</div>

    
</div>

</div></div>

    
</div>
    </div>
</template>

<script>
import FooterData from "../api/dataservice";
import DefaultFooterData from "../FallBackFiles/DefaultFooter.json";
export default {
    name: "FooterComponent",
    data() {
        return {
            footerData: {},
            getCurrentYear: '',
            environment: 'stage'
        }
    },
    mounted: function() {
        this.getCurrentYear = new Date().getFullYear();
        if (this.environment === 'prod') {
        FooterData.getFooterData()
                .then((data) => {
                    this.renderFooterData(data);
                })
                .catch(function() {
                });
        } else {
            this.renderFooterData(DefaultFooterData);
        }
    },
    methods: {
        renderFooterData(data) {
            this.footerData = data;
        },
    }
}
</script>
<style>
footer img[src*="microchip"][src*="logo"] {
    width: 0px !important;
    padding-bottom: 0px !important;
}
</style>